import React, { useState } from 'react';
import { Send, Camera, X } from 'lucide-react';
import VisitSummaryModal from './VisitSummaryModal';

const VisitSummaryButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Compact floating button */}
      <button
        onClick={() => setShowModal(true)}
        className="fixed bottom-4 right-4 bg-gradient-to-r from-pastel-blue to-pastel-purple text-white font-medium px-4 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200 flex items-center space-x-2 z-20 group"
        title="Leave After Visit Summary"
      >
        <Send className="h-5 w-5" />
        <span className="hidden lg:inline text-sm">Visit Summary</span>
      </button>

      {showModal && (
        <VisitSummaryModal 
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default VisitSummaryButton;
